import { useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import { getLink, sendCallToAPI } from "../../../common/generic_functions";
import { links } from "../links";
import { ResetPassword } from "./resetPassword";
import { useSearchParams } from "react-router-dom";
import { LoginWrapper } from "./wrappers";
import { LoginCreds, SecCodeVerification, ForgotPassword } from "./forms";
import { AlertContext } from "../login";
import "../login.sass";


const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

export const LoginComponent = ({ LoginContext }) => {
  const [forgot, setForgot] = useState(false);
  const [searchParams] = useSearchParams();
  const [userEmail, setUserEmail] = useState(null);
  const [isHovering, setIsHovering] = useState(false);
  // const { setMessageProps, success, setLoading } = useContext(LoginContext);
  const methods = useForm();
  const onSubmit = (data) => login(data);
  const onSubmitWithMFA = (data) => loginWithMFA(data);
  const { setMessageProps, success, setLoading } = useContext(LoginContext);
  const [formStage, setFormStage] = useState("login");
  const { enableAlert } = useContext(AlertContext);

  const forgetPasswordFormStart = () => {
    if (forgot) return;
    setForgot(true);
    setFormStage("forgot");
  };

  const _resetPasswordAccessToken = searchParams.get("resetPasswordAccessToken");
  const _email = searchParams.get("email");
  const _purpose = searchParams.get("purpose");
  const _authuser = searchParams.get("authuser");
  const auth_token = getCookie('auth_token');
  


// Usage




   

  useEffect(() => {
    if (auth_token) {
      const auth_token = getCookie('auth_token');
      let data = { "accessToken": auth_token }
      success(data)
    }
  }, []);



  useEffect(() => {
    if (_resetPasswordAccessToken) {
      setUserEmail(_email);
      setFormStage("reset");
      // searchParams.delete("resetPasswordAccessToken");
      // searchParams.delete("email");
      // setSearchParams(searchParams);
    }
  }, [searchParams]);

  const handleBackClick = () => {
    setForgot(false);
    setFormStage("login");
  };

  const login = async (formdata) => {
    setLoading(true);
    const link = getLink("", links, "login_mfa");
    let result;
    let messageProps = {};
    try {
      result = await sendCallToAPI(link, "notoken", formdata, "POST");
      if (result?.message && result?.status === "danger") {
        throw new Error({ text: result.message, messageType: result.status });
      } else if (result && result?.status) {

      

        if (result && result?.internal === true) {
            setLoading(true)
            messageProps = { type: result.status, text: "Redirecting to Microsoft SSO Login" };
            const redirectEntraLink = getLink("", links, "login_entra");
            window.location.href = redirectEntraLink;
            //if (result?.accessToken) {
           //success(result);
         // }


        } else {
          if (Object.keys(result).includes("oneTimeAccessToken")) {
            messageProps = { type: result.status, text: "One-time password accepted, please set your new password now." };
          } else {
            setFormStage("code");
            messageProps = { type: result.status, text: "We send a security code to your email address" };
          }
        }
      }
    } catch (e) {
      messageProps = e.messageType ? e : { type: "danger", text: "Sorry, an unexpected error has occurred!" };
    } finally {
        if(result?.internal !== true){
 enableAlert(messageProps);
      setLoading(false);
        }
     
    }
  };

  const loginWithMFA = async (formdata) => {
    const link = getLink("", links, "login_mfa_validation");
    let result;
    let messageProps = {};
    try {
      result = await sendCallToAPI(link, "notoken", formdata, "POST");
      if (result?.message && result?.status === "danger") {
        throw new Error({ text: result.message, messageType: result.status });
      } else if (result && result?.status) {
        messageProps = { type: result.status, text: "We send a security code to your email address" };
      }
      if (result?.accessToken) {
        success(result);
      }
    } catch (e) {
      messageProps = e.messageType ? e : { type: "danger", text: "Sorry, an unexpected error has occurred!" };
    } finally {
      enableAlert(messageProps);
      setLoading(false);
    }
  };

  return (
    <LoginWrapper purpose={_purpose} isHovering={isHovering} setIsHovering={setIsHovering}>
      <div className="login-content" style={{ height: _purpose ? "350px" : "100px" }}>
        <div className="form-wrapper" style={{ height: _purpose ? "500px" : "250px" }}>
          <div className={`form-slider stage-${formStage}`}>
            <div className="form-screen">
              <LoginCreds
                onSubmit={onSubmit}
                setIsHovering={setIsHovering}
                LoginContext={LoginContext}
                forgot={forgot}
                forgetPasswordFormStart={forgetPasswordFormStart}
                formStage={formStage}
                methods={methods}
              />
            </div>
            <div className="form-screen">
              <SecCodeVerification onSubmit={onSubmitWithMFA} methods={methods} handleBackClick={handleBackClick} />
            </div>
            <div className="form-screen">
              <ForgotPassword handleBackClick={handleBackClick} LoginContext={LoginContext} />
            </div>
            <div className="form-screen">
              <ResetPassword
                handleBackClick={handleBackClick}
                isTokenAvailable={_resetPasswordAccessToken}
                email={userEmail}
                purpose={_purpose}
                LoginContext={LoginContext}
              />
            </div>
          </div>
        </div>
      </div>
    </LoginWrapper>
  );
};
